import { SVGProps } from 'react';

export const BadgeUserIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width='13'
		height='13'
		viewBox='0 0 24 24'
		fill='none'
		stroke='currentColor'
		strokeWidth='2.2'
		strokeLinecap='round'
		strokeLinejoin='round'
		xmlns='http://www.w3.org/2000/svg'
		{...props}
	>
		<circle cx='12' cy='8' r='3.6' />
		<path d='M5 20.5c.8-4 3.8-5.5 7-5.5s6.2 1.5 7 5.5' />
	</svg>
);
